import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsColumnComponent } from './components/buttons-column/buttons-column.component';
import { DatatableSuportComponent } from './components/datatable-support/datatable-suport.component';
import { SearchAllTableComponent } from './components/search-all-table/search-all-table.component';
import { SearchColumnComponent } from './components/search-column/search-column.component';
import { StatusColumnComponent } from './components/status-column/status-column.component';
@NgModule({
    declarations: [
        StatusColumnComponent,
        SearchColumnComponent,
        SearchAllTableComponent,
        ButtonsColumnComponent,
        DatatableSuportComponent,
    ],
    exports: [
        StatusColumnComponent,
        SearchColumnComponent,
        SearchAllTableComponent,
        ButtonsColumnComponent,
        DatatableSuportComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
        MatRippleModule,
        MatTooltipModule,
        MatDialogModule,
        MatCheckboxModule,
        FormsModule,
        DragDropModule,
        MatMenuModule,
        MatDialogModule,
    ],
})
export class DatatableUtilsModule {}
